export const add_page = (payload) => ({
  type: "ADD_PAGE",
  payload: payload,
});
export const add_page_name = (payload) => ({
  type: "ADD_PAGE_NAME",
  payload: payload,
});
export const set_pages = (payload) => ({
  type: "SET_PAGES",
  payload: payload,
});

export const set_path = (path) => ({
  type: "SET_PATH",
  payload: path,
});

// Auth Actions

export const set_uid = (uid) => ({
  type: "SET_UID",
  payload: uid,
});
export const clear_uid = () => ({
  type: "CLEAR_UID",
});
export const set_email = (email_) => ({
  type: "SET_EMAİL",
  payload: email_,
});
export const clear_email = () => ({
  type: "CLEAR_EMAİL",
});

export const set_username = (username) => ({
  type: "SET_USERNAME",
  payload: username,
});

export const add_plc = (plc) => ({
  type: "ADD_PLC",
  payload: plc,
});
export const remove_plc = (id) => ({
  type: "REMOVE_PLC",
  id: id,
});
export const edit_plc = (id, payload) => ({
  type: "EDIT_PLC",
  id: id,
  payload: payload,
});

export const add_channel = (plc) => ({
  type: "ADD_CHANNEL",
  payload: plc,
});
export const remove_channel = (id) => ({
  type: "REMOVE_CHANNEL",
  id: id,
});
export const edit_channel = (id, payload) => ({
  type: "EDIT_CHANNEL",
  id: id,
  payload: payload,
});

export const add_points = (plc) => ({
  type: "ADD_POINT",
  payload: plc,
});
export const remove_points = (id) => ({
  type: "REMOVE_POINT",
  id: id,
});
export const edit_points = (id, payload) => ({
  type: "EDIT_POINT",
  id: id,
  payload: payload,
});
export const set_profile_infos = (payload) => ({
  type: "SET_PROFILE_INFO",
  payload: payload,
});

export const SET_COMPANY_ID = (id) => ({
  type: "SET_COMPANY_ID",
  id: id,
});

export const CLEAR_COMPANY_ID = () => ({
  type: "CLEAR_CID",
});

export const set_tag_list = (list_) => ({
  type: "SET_TAG_LIST",
  payload: list_,
});
export const set_tag_ids = (list_) => ({
  type: "SET_TAG_IDS",
  payload: list_,
});
export const set_temp_email = (email) => ({
  type: "SET_TEMP_EMAIL",
  payload: email,
});
export const clear_temp_email = (email) => ({
  type: "CLEAR_TEMP_EMAIL",
  payload: email,
});
export const set_tag_values = (list_) => ({
  type: "SET_TAG_VALUES",
  payload: list_,
});
export const set_main_path = (path) => ({
  type: "SET_MAIN_PATH",
  path: path,
});

export const set_plc = (payload) => ({
  type: "SET_PLC",
  payload: payload,
});

export const set_channel_action = (list) => ({
  type: "SET_CHANNELS",
  payload: list,
});

export const alarm_popup_control_func = (payl)=>({
  type:"ALARM_POPUP_CONTROL",
  payload:payl
})

export const set_alarms_action = (alarm_list) => ({
  type: "SET_ALARM",
  payload: alarm_list,
});
export const set_alarms_action2 = (alarm_list) => ({
  type: "SET_ALARM2",
  payload: alarm_list,
});
export const set_notis_action = (UYARI_list) => ({
  type: "SET_UYARI",
  payload: UYARI_list,
});
export const set_pages_names_action = (list) => ({
  type: "SET_PAGES_NAMES",
  payload: list,
});

export const set_white_space = (payload) => ({
  type: "SET_WHITE_SPACE",
  payload: payload,
});
export const set_toolbox = (payload) => ({
  type: "SET_toolbox",
  payload: payload,
});
export const set_render_items_toolbox = (payload) => ({
  type: "SET_render_toolbox_items",
  payload: payload,
});
export const add_render_items_toolbox = (payload) => ({
  type: "ADD_render_toolbox_items",
  payload: payload,
});

export const remove_render_items = () => ({
  type: "REMOVE_render_toolbox_items",
});

export const remove_paGE = (id) => ({
  type: "REMOVE_PAGE",
  id: id,
});

export const remove_Widget = (id) => ({
  type: "REMOVE_WIDGET",
  id: id,
});

export const add_pop_up_widget = (payload) => ({
  type: "ADD_POP_UP_WIDGET",
  payload: payload,
});

export const clear_pop_up_widget = () => ({
  type: "CLEAR_POP_UP_WIDGET",
});

export const set_temp_id = (payload) => ({
  type: "SET_TEMP_ID",
  payload: payload,
});

export const SET_FETCH_TAG_VALUE_CONTROL = (payload) => ({
  type: "SET_FETCH_TAG_VALUE_CONTROL",
  control: payload,
});

export const set_system_moni_control = (payload) => ({
  type: "SET_SYSTEM_MON_CONTROL",
  payload: payload,
});

export const set_energy_tags = (payload) => ({
  type: "SET_ENERGY_TAGS",
  payload: payload,
});
export const set_energy_tags2 = (payload) => ({
  type: "SET_ENERGY_TAGS2",
  payload: payload,
});
export const set_energy_tags3 = (payload) => ({
  type: "SET_ENERGY_TAGS3",
  payload: payload,
});
export const set_sıcak_su_sistemi = (payload) => ({
  type: "SET_SICAK_SU_SİSTEM",
  payload: payload,
});

export const set_vrf_tags = (payload) => ({
  type: "SET_VRF_TAGS",
  payload: payload,
});

export const set_pumps_tags = (payload) => ({
  type: "SET_PUMPS_TAGS",
  payload: payload,
});

export const set_booster_tags = (payload) => ({
  type: "SET_BOOSTER_TAGS",
  payload: payload,
});

export const set_fans_tags = (payload) => ({
  type: "SET_FANS_TAGS",
  payload: payload,
});

export const set_vrfks_tags = (payload) => ({
  type: "SET_VRFKS_TAGS",
  payload: payload,
});
export const set_vrfhacim_tags = (payload) => ({
  type: "SET_VRFHacim_TAGS",
  payload: payload,
});

export const set_vrf5_tags = (payload) => ({
  type: "SET_VRF5_TAGS",
  payload: payload,
});

export const set_vrf4_tags = (payload) => ({
  type: "SET_VRF4_TAGS",
  payload: payload,
});
export const set_vrf3_tags = (payload) => ({
  type: "SET_VRF3_TAGS",
  payload: payload,
});
export const set_vrf2_tags = (payload) => ({
  type: "SET_VRF2_TAGS",
  payload: payload,
});
export const set_ucer_id = (payload) => ({
  type: "SET_UCER_ID",
  payload: payload,
});
export const set_booster_calis_dur = (payload) => ({
  type: "SET_B_C_D_K_L",
  payload: payload,
});
export const set_vrf_komut_list = (payload) => ({
  type: "SET_VRF_KOMUT_LIST",
  payload: payload,
});

export const set_notis_last = (id) => ({
  type: "SET_NOTIS_LAST",
  payload: id,
});

export const set_dashboard_data = (payload) => ({
  type: "SET_DASHBOARD_DATA",
  payload: payload,
});

export const set_water_storage = (payload) => ({
  type: "SET_WATER_STORAGE",
  payload: payload,
});

export const set_hidrofor = (payload) => ({
  type: "SET_HIDROFOR_STATE",
  payload: payload,
});

export const set_vrf_teras_tags = (payload) => ({
  type: "SET_VRF_TERAS_TAGS",
  payload: payload,
});

export const set_misafir_oda = (payload) => ({
  type: "SET_MISAFIR_ODA",
  payload: payload,
});

export const set_external_trend_info = (payload) => ({
  type: "SET_EXTERNAL_TREND_INFO",
  payload: payload,
});
export const set_external_trend_info_cop = (payload) => ({
  type: "SET_EXTERNAL_TREND_INFO_COP",
  payload: payload,
});

export const set_tags_for_trend_page = (payload) => ({
  type: "SET_TAGS_FOR_TRENDS_PAGE",
  payload: payload,
});
export const set_dynamicpageWS = (payload) => ({
  type: "SET_DYNAMICPAGEWS",
  payload: payload,
});
export const add_dynamicpageWS = (payload) => ({
  type: "ADD_DYNAMICPAGEWS",
  payload: payload,
});
export const delete_dynamicpageWS = (payload) => ({
  type: "DELETE_DYNAMICPAGEWS",
  id_: payload,
});

export const add_group_item = (payload) => ({
  type: "ADD_GROUP_ITEM",
  payload: payload,
});
export const add_user_item = (payload) => ({
  type: "ADD_USER_ITEM",
  payload: payload,
});

export const set_group_item = (payload) => ({
  type: "SET_GROUP_ITEM",
  payload: payload,
});
export const set_user_item = (payload) => ({
  type: "SET_USER_ITEM",
  payload: payload,
});
export const set_yetkilendirme_state = (payload) => ({
  type: "SET_YETKİLENDİRME",
  payload: payload,
});

export const set_combine_trends = (payload) => ({
  type: "SET_COMBINE_TRENDS",
  payload: payload,
});

export const set_group_id = (payload) => ({
  type: "SET_GROUP_ID",
  payload: payload,
});

export const set_cop = (payload) => ({
  type: "SET_COP",
  payload: payload,
});

export const set_wp_temp = (payload) => ({
  type: "SET_WP_TEMP",
  payload: payload,
});

export const setTesis = (payload) => ({
  type: "SET_TESİS",
  payload: payload,
});

export const setProfilePhoto = (payload) => ({
  type: "SET_PROFILE_PHOTO",
  payload: payload,
});

export const setTotalizerTags = (payload) => ({
  type: "SET_TOTALIZER_TAGS",
  payload: payload,
});

export const setCompaniesList = (payload) => ({
  type: "SET_COMPANIES_LIST",
  payload: payload,
});

export const setCanvasBoyut = (payload) => ({
  type: "SET_CANVAS_BOYUT",
  payload: payload,
});

export const set_reactflowList = (payload) => ({
  type: "SET_REACTFLOWList",
  payload: payload,
});

export const set_widget_library = (payload) => ({
  type: "SET_WIDGET_LIBRARY",
  payload: payload,
});

export const set_current_page_details = (payload) => ({
  type: "SET_CURRENT_PAGE_DETAILS",
  payload: payload,
});
export const set_current_dyn_pageName = (payload) => ({
type:"SET_CURRENT_DYN_PAGENAME",
  payload: payload,
});

export const set_fetch_pages_control = (payload) => ({
  type:"SET_FETCH_PAGES_CONTROL",
    payload: payload,
  });

export const set_temp_com_id = (payload)=>({
  type:"SET_TEMP_COM_ID",
  payload:payload
})

export const set_company_logo_url = (payload)=>({
  type:"SET_COMPANY_LOGO_URL",
  payload:payload
})